<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent" ref="YSZDtable" :loading="loading" ></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [modalMixins, listMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
			type: {
				default: () => {
					return 'month'
				}
			},
			unit: {
				default: () => {
					return 'month'
				}
			},
		},
		data() {
			return {
				loading:false,
				modal_title: '',
				modal_width: 1200,
				modal_height: 800,
				form: {
					date: [],
					type: null
				},
				list_formConfig: [{
					field: 'date',
					title: '日期',					
					itemRender: {
						defaultValue:[
							this.$Moment().subtract(1, 'day').startOf('day').valueOf(),
							this.$Moment().subtract(1, 'day').endOf('day').valueOf()
						],
						name: '$datePicker'
					}
				}],
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.columns = [{
						field: 'child_name',
						title: '店铺'
					},
					{
						title: '支付宝',
						align: 'center',
						children: [
							// {
							// 	field: 'zhifubao_initAmount',
							// 	title: '期初金额',
							// 	align: 'center'
							// },
							{
								field: 'zhifubao_inAmount',
								title: '收入金额',
								align: 'center'
							},
							{
								field: 'zhifubao_cash',
								title: '提现',
								align: 'center'
							},
							// {
							// 	field: 'zhifubao_outAmount',
							// 	title: '支出金额',
							// 	align: 'center'
							// },
							// {
							// 	field: 'zhifubao_endAmount',
							// 	title: '期末金额',
							// 	align: 'center'
							// }
						]
					},
					{
						title: '余利宝',
						children: [
							// {
							// 	field: 'yulibao_initAmount',
							// 	title: '期初金额',
							// 	align: 'center',
							// 	editRender: {
							// 		name: '$inputNumber',
							// 		props:{
							// 			precision:2
							// 		},
							// 		events:{
							// 			change:this.computeYulibaoendAmount
							// 		}
							// 	}
							// },
							{
								field: 'yulibao_inAmount',
								title: '收入金额',
								align: 'center'
							},
							{
								field: 'yulibao_outAmount',
								title: '支出金额',
								align: 'center'
							},
							// {
							// 	field: 'yulibao_endAmount',
							// 	title: '期末金额',
							// 	align: 'center'
							// }

						],
						align: 'center'
					},
					{
						title: '状态',
						field: 'status',
						align: 'center'
					}
				]
				gridOptions.toolbarConfig.buttons = [{
					name: '获取数据',
					status: 'primary',
					code: 'getdata'
				},{
					name: '导出',
					status: 'success',
					code: 'export'
				}]
				//gridOptions.formConfig = false
			},
			init_formButton() {
				this.list_formButton = []
			},
			getdata(){
				let fullData = this.$refs.YSZDtable.getTableData().fullData
				let getFormData = this.$refs.YSZDtable.getProxyInfo().form
				if(!getFormData.date){
					this.$message.error('请选择日期')
					return
				}
				fullData.forEach((item)=>{
					item.status = ''
					this.loading = true
					let child_key = item.child_key
					this.$api.downloadstatic.getexcle({
						code: this.data.code,
						child_key: child_key,
						date:getFormData.date.join(',')
					}).then((res) => {
						let data = res.data
						let obj = fullData.find((d)=>{
							return d.child_key == child_key
						})
						if(obj){
							//obj.yulibao_initAmount = data.yulibao.initAmount
							obj.yulibao_inAmount = data.yulibao.inAmount
							obj.yulibao_outAmount = data.yulibao.outAmount						
							obj.yulibao_endAmount = data.yulibao.endAmount
							
							obj.zhifubao_initAmount = data.zhifubao.initAmount
							obj.zhifubao_inAmount = data.zhifubao.inAmount
							obj.zhifubao_outAmount = data.zhifubao.outAmount						
							obj.zhifubao_endAmount = data.zhifubao.endAmount
							obj.zhifubao_cash = data.zhifubao.cash
							obj.status = '获取成功'
						}
						//console.log(res)
						this.computeYulibaoendAmount()
						this.loading = false
					},()=>{
						this.loading = false
					})
				})
			},
			computeYulibaoendAmount(){
				let fullData = this.$refs.YSZDtable.getTableData().fullData
				//console.log(fullData)
				fullData.forEach((item)=>{
					item.yulibao_initAmount = item.yulibao_initAmount ? item.yulibao_initAmount:0
					item.yulibao_endAmount = parseFloat(item.yulibao_initAmount) + parseFloat(item.yulibao_inAmount) + parseFloat(item.yulibao_outAmount)
					item.yulibao_endAmount = item.yulibao_endAmount.toFixed(2)
				})
			},
			list() {
				return new Promise((resolve) => {
					this.$api.downloadstatic.getexcle({
						code: this.data.code
					}).then((res) => {
						resolve({
							list: res.data
						})
					})
				})

			},
			modal_init() {
				this.form = {
					date: [],
					type: null
				}
				this.modal_title = this.data.name
				this.modal_model = true
			},
			// modal_show(){

			// 	this.$api.downloadstatic.getexcle({
			// 		code: this.data.code,
			// 	}).then(() => {
			// 		this.$message.success('创建下载任务成功，文件将推送至钉钉')
			// 		this.modal_cancel()
			// 	})
			// },
			submit() {
				if (!this.form.date.length) {
					this.$message.error('请选择统计时间')
					return
				}
				if (!this.form.type) {
					this.$message.error('请选择统计类型')
					return
				}
				this.$api.downloadstatic.getexcletask({
					code: this.data.code,
					type: this.form.type,
					begin: this.form.date[0] / 1000,
					end: this.form.date[1] / 1000,
				}).then(() => {
					this.$message.success('创建下载任务成功，文件将推送至钉钉')
					//this.modal_cancel()
				})
			},
			reset() {

			}
		},
		components: {

		}
	}
</script>